import React from "react";
import withLabel from "./withLabel";
import withFormBindings from "./withFormBindings";

const InputField = (props) => <input {...props} className="mt2 outline-0 field-padding mid-gray w-100 ba b--black-20" />
export default withFormBindings(withLabel(InputField))
